import classNames from 'classnames';
import { omit } from 'lodash';
import React from 'react';
import { trackError } from '../../../../app-config/errorTracking';

interface ContainerProps extends Omit<any, never> {
    name: string;
    selected?: any;
    onChange: (value: any) => void;
    className?: string;
    children: React.ReactNode;
}

export const RadioButtonContainerPlain = ({
    className = undefined,
    ...props
}: Omit<ContainerProps, 'name' | 'selected' | 'onChange'>) => (
    <div className={classNames(className, 'styled-radio-inputs')} {...props} />
);

export type RadioButtonContext = Pick<ContainerProps, 'name' | 'selected' | 'onChange'>;

export const InternalRadioButtonContext = React.createContext<RadioButtonContext>({
    name: '',
    onChange: () => {
        trackError('RadioButton was used but there is no corresponding RadioButtonContainer.');
    },
});

export default function RadioButtonContainer(props: ContainerProps) {
    const containerProps = omit(props, ['name', 'selected', 'onChange']);
    return (
        <InternalRadioButtonContext.Provider value={props}>
            <fieldset>
                <RadioButtonContainerPlain {...containerProps} />
            </fieldset>
        </InternalRadioButtonContext.Provider>
    );
}
